import {
  Badge,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Paper,
  Typography,
  Avatar,
  ListItemAvatar,
  Chip,
} from "@material-ui/core";
import Popover from "@material-ui/core/Popover";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import { isArray } from "lodash";
import React, {
  useContext,
  useEffect,
  useReducer,
  useState,
  useCallback,
  useMemo,
} from "react";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { markChatAsRead } from "../../services/chatService";
// import { SocketContext } from "../../context/Socket/SocketContext";
import { AuthContext } from "../../context/Auth/AuthContext";
import { useDate } from "../../hooks/useDate";

import useSound from "use-sound";
import notifySound from "../../assets/chat_notify.mp3";
import QuestionAnswerOutlinedIcon from '@material-ui/icons/QuestionAnswerOutlined';

const useStyles = makeStyles((theme) => ({  mainPaper: {
    flex: 1,
    width: 280, // ✅ Largura fixa definida
    maxHeight: 280, // ✅ Reduzido para caber ~3 itens (80px cada + padding)
    maxWidth: 280, // ✅ Ajustado para corresponder à largura fixa
    padding: 0,
    overflowY: "auto",
    ...theme.scrollbarStyles,
  },
  notificationIcon: {
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'scale(1.1)',
    }  },  chatItem: {
    padding: theme.spacing(1), // ✅ Reduzido de 1.5 para 1
    borderBottom: `1px solid ${theme.palette.divider}`,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    minHeight: 75, // ✅ Altura mínima definida
    maxHeight: 85, // ✅ Altura máxima para controle
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    '&:last-child': {
      borderBottom: 'none',
    }
  },
  chatItemUnread: {
    backgroundColor: 'rgba(37, 211, 102, 0.08)',
    borderLeft: '3px solid #25D366',
    '&:hover': {
      backgroundColor: 'rgba(37, 211, 102, 0.15)',
    },
  },chatAvatar: {
    width: 38, // ✅ Reduzido de 45 para 38
    height: 38, // ✅ Reduzido de 45 para 38
    fontSize: '14px', // ✅ Reduzido de 16px para 14px
    fontWeight: 600,
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  },  userInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 3, // ✅ Reduzido de 4 para 3
  },
  userName: {
    fontWeight: 600,
    fontSize: '13px', // ✅ Reduzido de 14px para 13px
    color: theme.palette.text.primary,
  },
  messageTime: {
    fontSize: '10px', // ✅ Reduzido de 11px para 10px
    color: theme.palette.text.disabled,
  },
  chatInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 4, // ✅ Reduzido de 6 para 4
  },
  chatTitle: {
    fontWeight: 500,
    fontSize: '12px', // ✅ Reduzido de 13px para 12px
    color: theme.palette.text.secondary,
  },  unreadBadge: {
    backgroundColor: '#25D366',
    color: 'white',
    fontSize: '9px', // ✅ Reduzido de 10px para 9px
    fontWeight: 700,
    minWidth: 14, // ✅ Reduzido de 16 para 14
    height: 14, // ✅ Reduzido de 16 para 14
    borderRadius: 7, // ✅ Ajustado para metade da altura
  },
  lastMessage: {
    fontSize: '12px', // ✅ Reduzido de 13px para 12px
    color: theme.palette.text.secondary,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontStyle: 'italic',
    lineHeight: 1.1, // ✅ Reduzido de 1.2 para 1.1
  },
  headerContainer: {
    padding: theme.spacing(1.5),
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    textAlign: 'center',
  },
  headerTitle: {
    fontSize: '16px',
    fontWeight: 600,
  },  emptyState: {
    padding: theme.spacing(2), // ✅ Reduzido de 3 para 2
    textAlign: 'center',
    color: theme.palette.text.secondary,
    minHeight: 120, // ✅ Altura mínima para o estado vazio
  },
}));

const reducer = (state, action) => {
  if (action.type === "LOAD_CHATS") {
    const chats = action.payload;
    const newChats = [];

    if (isArray(chats)) {
      chats.forEach((chat) => {
        const chatIndex = state.findIndex((u) => u.id === chat.id);
        if (chatIndex !== -1) {
          state[chatIndex] = chat;
        } else {
          newChats.push(chat);
        }
      });
    }

    return [...state, ...newChats];
  }

  if (action.type === "UPDATE_CHATS") {
    const chat = action.payload;
    const chatIndex = state.findIndex((u) => u.id === chat.id);

    if (chatIndex !== -1) {
      state[chatIndex] = chat;
      return [...state];
    } else {
      return [chat, ...state];
    }
  }

  if (action.type === "DELETE_CHAT") {
    const chatId = action.payload;

    const chatIndex = state.findIndex((u) => u.id === chatId);
    if (chatIndex !== -1) {
      state.splice(chatIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }

  if (action.type === "CHANGE_CHAT") {
    const updatedChat = action.payload.chat;
    const chatIndex = state.findIndex((chat) => chat.id === updatedChat.id);
    
    if (chatIndex !== -1) {
      const newState = [...state];
      newState[chatIndex] = updatedChat;
      return newState;
    } else {
      return [updatedChat, ...state];
    }
  }
};

export default function ChatPopover() {  const classes = useStyles();
  const history = useHistory();

  //   const socketManager = useContext(SocketContext);
  const { user, socket } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [searchParam] = useState("");
  const [chats, dispatch] = useReducer(reducer, []);  const [invisible, setInvisible] = useState(true);
  const [totalUnreadCount, setTotalUnreadCount] = useState(0);  // ✅ Som de notificação otimizado
  // Volume global: lê do localStorage (numérico) ou usa 0.33 como padrão
  const getGlobalVolume = () => {
    const raw = localStorage.getItem('volume');
    if (raw === null || raw === '') return 0.33;
    const v = Number(raw);
    if (!Number.isFinite(v)) return 0.33;
    return Math.min(1, Math.max(0, v));
  };
  const [play] = useSound(notifySound, { 
    volume: getGlobalVolume(),
    interrupt: true,
    format: ['mp3']
  });
  // ✅ Função simples para tocar som - memoizada para evitar re-renders
  const fallbackAudioRef = React.useRef(null);
  const playSound = useCallback(() => {
    // Primeiro, tentar usar o useSound
    try {
      if (typeof play === 'function') {
        play();
        return; // Se funcionou, não precisa do fallback
      }
    } catch (error) {
      console.warn('⚠️ [ChatPopover] Erro no useSound:', error);
    }

    // Fallback: Tentar Audio() direto
    try {
      if (!fallbackAudioRef.current) {
        fallbackAudioRef.current = new Audio(notifySound);
        fallbackAudioRef.current.preload = 'auto';
      }
  const audio = fallbackAudioRef.current;
  audio.volume = getGlobalVolume();
      audio.currentTime = 0;
      const playPromise = audio.play();
      if (playPromise !== undefined) {
        playPromise.then(() => {
          // Som tocado com sucesso
        }).catch((e) => {
          console.error('❌ [ChatPopover] Falha ao tocar som:', e);
        });
      }
    } catch (e) {
      console.error('❌ [ChatPopover] Falha completa ao tocar som:', e);
    }
  }, [play]);  useEffect(() => {
    if (!("Notification" in window)) {
      console.log("This browser doesn't support notifications");
    } else {
      Notification.requestPermission();
    }
  }, []);

  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
  }, [searchParam]);  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      fetchChats();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParam, pageNumber]);
  const fetchChats = async () => {
    try {
      const { data } = await api.get("/chats/", {
        params: { searchParam, pageNumber },
      });
      
      dispatch({ type: "LOAD_CHATS", payload: data.records });
      setHasMore(data.hasMore);
      setLoading(false);
    } catch (err) {
      console.error('❌ [ChatPopover] Erro ao buscar chats:', err);
      toastError(err);
    }
  };  // Função para refrescar chats quando necessário
  const refreshChats = useCallback(() => {
    setLoading(true);
    dispatch({ type: "RESET" });
    
    // ✅ Chamar fetchChats diretamente ao invés de confiar no useEffect
    setTimeout(() => {
      fetchChats();
    }, 100);
  }, []);// Memoiza os canais para evitar recriação desnecessária
  const socketChannels = useMemo(() => {
    if (!user?.companyId || !user?.id) return null;
    return {
      userChannel: `company-${user.companyId}-chat-user-${user.id}`,
      chatChannel: `company-${user.companyId}-chat`
    };
  }, [user]);
  useEffect(() => {
    if (socketChannels && socket?.on && socket?.off) {
      const { userChannel, chatChannel } = socketChannels;

      const onChatUserPopover = (data) => {
        if (data.action === "new-message") {
          const isUserInvolved = data.chat?.users?.some(chatUser => 
            chatUser.userId === user.id
          );
            if (isUserInvolved) {
            const isFromCurrentUser = data.newMessage?.senderId === user.id;
            dispatch({ type: "CHANGE_CHAT", payload: data });
              if (!isFromCurrentUser) {
              playSound();
            }
          }
        } else if (data.action === "update" || data.action === "delete") {
          // Refresh lista quando há updates/deletes importantes
          refreshChats();
        }
      };

      const onCompanyChatPopover = (data) => {
        if (data.action === "new-message") {
          const isUserInvolved = data.chat?.users?.some(chatUser => 
            chatUser.userId === user.id
          );
            if (isUserInvolved) {
            dispatch({ type: "CHANGE_CHAT", payload: data });
              if (data.newMessage && data.newMessage.senderId !== user.id) {
              playSound();
              
              if (Notification.permission === "granted") {
                new Notification(`Nova mensagem no chat interno`, {
                  body: data.newMessage.body || 'Nova mensagem',
                  icon: '/favicon.ico',
                  tag: `chat-${data.chat.id}`,
                });
              }
            }
          }
        }
        
        if (data.action === "update") {
          dispatch({ type: "CHANGE_CHAT", payload: data });
        } else if (data.action === "delete") {
          // Refresh lista quando chat é deletado
          refreshChats();
        }
      };
      
      socket.on(userChannel, onChatUserPopover);
      socket.on(chatChannel, onCompanyChatPopover);

      return () => {
        socket.off(userChannel, onChatUserPopover);
        socket.off(chatChannel, onCompanyChatPopover);
      };
    }  }, [socketChannels, socket, user.id, playSound, refreshChats]);
  // Listener para eventos customizados de sincronização
  useEffect(() => {
    const handleChatRead = (event) => {
      const { userId } = event.detail;
      if (userId === user.id) {
        // Refresh a lista para garantir sincronização
        refreshChats();
      }
    };

    window.addEventListener('chatRead', handleChatRead);
    return () => {
      window.removeEventListener('chatRead', handleChatRead);
    };
  }, [user.id, refreshChats]);  useEffect(() => {
    let unreadsCount = 0;
    let chatsWithUnreadsCount = 0;
    
    if (chats.length > 0) {
      chats.forEach(chat => {
        const chatUser = chat.users?.find(u => u.userId === user.id);
        const unreadCount = chatUser?.unreads || 0;
        if (unreadCount > 0) {
          unreadsCount += unreadCount;
          chatsWithUnreadsCount += 1;
        }
      });
    }
    
    setTotalUnreadCount(unreadsCount);
    // ✅ Mostrar badge apenas se houver conversas com mensagens não lidas
    setInvisible(chatsWithUnreadsCount === 0);
  }, [chats, user.id]);

  const loadMore = () => {
    setPageNumber((prevState) => prevState + 1);
  };

  const handleScroll = (e) => {
    if (!hasMore || loading) return;
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - (scrollTop + 100) < clientHeight) {
      loadMore();
    }
  };  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setInvisible(true);
    
    // ✅ NÃO fazer refresh - os dados já estão atualizados via Socket
    // ✅ Só fazer refresh se não há dados
    if (chats.length === 0) {
      refreshChats();
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  
  const getAvatarText = (title) => {
    if (!title) return '?';
    const words = title.split(' ');
    if (words.length >= 2) {
      return (words[0][0] + words[1][0]).toUpperCase();
    }
    return title.slice(0, 2).toUpperCase();
  };

  const formatTime = (dateString) => {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    const now = new Date();
    const diffInDays = Math.floor((now - date) / (1000 * 60 * 60 * 24));
    
    if (diffInDays === 0) {
      return date.toLocaleTimeString('pt-BR', { 
        hour: '2-digit', 
        minute: '2-digit' 
      });
    } else if (diffInDays === 1) {
      return 'Ontem';
    } else if (diffInDays < 7) {
      return date.toLocaleDateString('pt-BR', { weekday: 'short' });
    } else {
      return date.toLocaleDateString('pt-BR', { 
        day: '2-digit', 
        month: '2-digit' 
      });
    }
  };
  const getUnreadCount = (chat) => {
    const chatUser = chat.users?.find(u => u.userId === user.id);
    const unreadCount = chatUser?.unreads || 0;
    return unreadCount;
  };

  const getLastMessageSender = (chat) => {
    if (chat.lastMessageSenderName) {
      return chat.lastMessageSenderName;
    }
    
    if (chat.lastMessageSenderId) {
      const lastSender = chat.users?.find(u => u.userId === chat.lastMessageSenderId);
      if (lastSender?.user?.name) {
        return lastSender.user.name;
      }
    }
    
    const otherUser = chat.users?.find(u => u.userId !== user.id && u.user?.name);
    if (otherUser?.user?.name) {
      return otherUser.user.name;
    }
    
    return 'Usuário desconhecido';
  };  const goToMessages = useCallback(async (chat) => {
    // Fechar o popover imediatamente para melhor UX
    setAnchorEl(null);
    
    // Navegar para o chat primeiro
    history.push(`/chats/${chat.uuid}`);
    
    try {
      // Marcar mensagens como lidas no backend
      // O socket irá notificar todas as atualizações necessárias
      await markChatAsRead(chat.id);
      
      // Disparar evento customizado para sincronizar com outros componentes
      window.dispatchEvent(new CustomEvent('chatRead', { 
        detail: { chatId: chat.id, userId: user.id } 
      }));
      
    } catch (error) {
      console.error('Erro ao marcar mensagens como lidas:', error);
    }
  }, [history, user.id]);

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  return (
    <div>
      <IconButton
        aria-describedby={id}
        variant="contained"
        color={invisible ? "default" : "inherit"}
        onClick={handleClick}
        size="small"
        className={classes.notificationIcon}
        style={{ color: "white" }}
      >
        <Badge 
          color="secondary" 
          badgeContent={totalUnreadCount > 99 ? '99+' : totalUnreadCount}
          invisible={invisible}
          classes={{ badge: classes.unreadBadge }}
        >
          <QuestionAnswerOutlinedIcon style={{ width: "28px", height: "26px" }} />
        </Badge>
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Paper
          variant="outlined"
          onScroll={handleScroll}
          className={classes.mainPaper}
        >          <List component="nav" disablePadding>            {(() => {
              const allChats = isArray(chats) ? chats : [];
              
              if (allChats.length > 0) {
                // ✅ Filtrar APENAS chats com mensagens não lidas
                const chatsWithUnreads = allChats.filter(chat => {
                  const unreadCount = getUnreadCount(chat);
                  const hasUnreads = unreadCount > 0;
                  return hasUnreads;
                });
                
                // ✅ Mostrar apenas os chats com mensagens não lidas (limitado a 5)
                const sortedChats = chatsWithUnreads.slice(0, 5);
                
                if (sortedChats.length > 0) {
                  return sortedChats.map((chat, key) => {
                    const unreadCount = getUnreadCount(chat);
                    const lastSender = getLastMessageSender(chat);
                    const hasUnreads = unreadCount > 0; // Sempre true aqui, mas mantendo para consistência
                    
                    return (
                      <ListItem
                        key={chat.id || key}
                        className={`${classes.chatItem} ${classes.chatItemUnread}`} // Sempre destacado
                        onClick={() => goToMessages(chat)}
                        button
                      >
                        <ListItemAvatar>
                          <Avatar 
                            className={classes.chatAvatar}
                            style={{
                              background: 'linear-gradient(135deg, #25D366 0%, #1ebe5a 100%)' // Sempre verde para não lidas
                            }}
                          >
                            {getAvatarText(chat.title)}
                          </Avatar>
                        </ListItemAvatar>
                        
                        <ListItemText
                          primary={
                            <div>
                              <div className={classes.userInfo}>
                                <Typography 
                                  className={classes.userName}
                                  style={{ 
                                    fontWeight: 700, // Sempre bold para não lidas
                                    color: '#1ebe5a'
                                  }}
                                >
                                  {lastSender}
                                </Typography>
                                <Typography className={classes.messageTime}>
                                  {formatTime(chat.updatedAt)}
                                </Typography>
                              </div>
                              <div className={classes.chatInfo}>
                                <Typography 
                                  className={classes.chatTitle}
                                  style={{ 
                                    fontWeight: 600 // Sempre bold para não lidas
                                  }}
                                >
                                  <span role="img" aria-label="localização">📍</span> {chat.title || 'Chat sem título'}
                                </Typography>
                                <Chip
                                  label={unreadCount > 99 ? '99+' : unreadCount}
                                  size="small"
                                  className={classes.unreadBadge}
                                />
                              </div>
                              
                              <Typography 
                                className={classes.lastMessage}
                                style={{ 
                                  fontWeight: 500, // Sempre semi-bold para não lidas
                                  fontStyle: 'normal'
                                }}
                              >
                                <span role="img" aria-label="mensagem">💬</span> {chat.lastMessage || 'Nova mensagem'}
                              </Typography>
                            </div>
                          }
                        />
                      </ListItem>
                    );
                  });
                }
              }
              
              // ✅ Estado vazio - nenhuma conversa não lida
              return (
                <div className={classes.emptyState}>
                  <QuestionAnswerOutlinedIcon style={{ fontSize: 36, marginBottom: 12, opacity: 0.5 }} />
                  <Typography variant="h6" style={{ marginBottom: 6, fontSize: '14px' }}>
                    Nenhuma mensagem não lida
                  </Typography>
                  <Typography variant="body2" style={{ opacity: 0.7, fontSize: '12px' }}>
                    Todas as conversas estão em dia! 📬
                  </Typography>
                </div>
              );
            })()}
          </List>
        </Paper>
      </Popover>
    </div>
  );
}
